import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Party = ({ title, p, testid }) => (
  <div className="rounded-lg border border-slate-200 bg-white p-3 text-sm" data-testid={testid}>
    <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{title}</p>
    <p className="font-semibold text-slate-900">{p?.name || "—"}</p>
    {(p?.address || []).map((a, i) => <p key={i} className="text-slate-600">{a}</p>)}
    {p?.gstin && <p className="text-slate-600">GSTIN : <span className="font-mono">{p.gstin}</span></p>}
  </div>
);

export function PIHeader({ pi, setPi, number, customer, delivery }) {
  const f = (k, label, type = "text") => (
    <div><Label className="text-xs text-slate-500">{label}</Label>
      <Input type={type} value={pi[k] || ""} onChange={(e) => setPi({ ...pi, [k]: e.target.value })} className="h-9" data-testid={`pi-field-${k}`} /></div>
  );
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <div><Label className="text-xs text-slate-500">PFI No.</Label>
          <div className="h-9 flex items-center rounded-md border border-dashed border-slate-300 bg-slate-50 px-3 font-mono font-semibold" data-testid="pi-number">{number}</div></div>
        {f("date", "Date", "date")}{f("contact", "Contact")}{f("phone", "Phone")}{f("email", "Email")}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Party title="Buyer" p={customer} testid="pi-buyer" />
        <div className="space-y-2">
          <Party title="Delivery address" p={delivery} testid="pi-delivery" />
          {f("po_text", "PO line (printed under delivery address)")}
        </div>
      </div>
    </div>
  );
}
